export const AUTH_PREFIX = 'auth';

export const INVALID_TOKEN_ERROR = 'Auth.TokenInvalid';
export const NOT_LOGGED_IN_ERROR = 'Auth.NotLoggedIn';
export const PAGE_RESTRICTED_FLAG = '1';

export const DONE       = 'auth/DONE';
export const LOAD       = 'auth/LOAD';
export const SET_USER   = 'auth/SET_USER';
export const CLEAR_USER = 'auth/CLEAR_USER';
export const SET_AUTH   = 'auth/SET_AUTH';
export const CLEAR_AUTH = 'auth/CLEAR_AUTH';

export interface IAuthToken {
  access_token: string;
  expires_in: number;
  created_at: number;
  refresh_token?: string;
  token_type: string;
  scope: string;
}
